<template>
  <div class="inventory-warning">
    <div class="toolbar">
      <div>
        <h3>库存提醒</h3>
        <span class="description">展示剩余库存不超过 8 件的最近 40 条记录</span>
      </div>
      <Button type="primary" icon="refresh" :loading="loading" @click="queryRecords">
        刷新
      </Button>
    </div>

    <Table
      border
      stripe
      :loading="loading"
      :columns="columns"
      :data="records"
      no-data-text="暂无库存提醒"
    ></Table>
  </div>
</template>

<script>
import { cmsProductRecordList } from "../../api/fahuo";

export default {
  data() {
    return {
      loading: false,
      records: [],
      columns: [
        {
          title: "时间",
          key: "createtime",
          minWidth: 170,
        },
        {
          title: "发货前数量",
          key: "beforenum",
          width: 120,
          align: "center",
        },
        {
          title: "剩余数量",
          key: "afternum",
          width: 110,
          align: "center",
          render: (h, params) => {
            return h(
              "Tag",
              {
                props: {
                  color: Number(params.row.afternum) <= 3 ? "red" : "orange",
                },
              },
              String(params.row.afternum)
            );
          },
        },
        {
          title: "商品名",
          key: "goodsname",
          minWidth: 220,
          render: (h, params) => h("span", params.row.goodsname || "-"),
        },
        {
          title: "商品图片",
          key: "goodsimg",
          width: 110,
          align: "center",
          render: (h, params) => {
            const url = this.getImageUrl(params.row.goodsimg);
            if (!url) {
              return h("span", "-");
            }
            return h("img", {
              attrs: {
                src: url,
                alt: params.row.goodsname || "商品图片",
              },
              style: {
                width: "56px",
                height: "56px",
                marginTop: "5px",
                objectFit: "cover",
                borderRadius: "4px",
              },
            });
          },
        },
        {
          title: "商品ID",
          key: "productid",
          width: 110,
          align: "center",
        },
      ],
    };
  },
  mounted() {
    this.queryRecords();
  },
  methods: {
    getImageUrl(url) {
      if (!url) {
        return "";
      }
      return /^https?:\/\//i.test(url) ? url : process.env.OSS + url;
    },
    queryRecords() {
      this.loading = true;
      cmsProductRecordList({})
        .then((response) => {
          this.records = Array.isArray(response.data) ? response.data : [];
        })
        .catch((error) => {
          this.records = [];
          this.$Message.error(error.message || "库存提醒加载失败");
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.inventory-warning {
  padding: 16px;
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.toolbar h3 {
  margin: 0 0 4px;
  font-size: 18px;
}

.description {
  color: #80848f;
}
</style>
